import { useMutation, useQueryClient } from '@tanstack/react-query';
import i18next from 'i18next';
import { useServices, useStores } from 'index';

type Callbacks = {
  onSuccess?: () => Promise<void> | void;
};

export const useDeleteInvites = (organizationId: string, callbacks?: Callbacks) => {
  const inviteStudentsService = useServices().inviteStudentsService;
  const queryClient = useQueryClient();
  const notificationsStore = useStores().notificationStore;

  return useMutation({
    mutationFn: (inviteIds: string[]) => inviteStudentsService.deleteInvitesAndUpdate(organizationId, inviteIds),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['organizationInvites', organizationId] }),
        queryClient.invalidateQueries({ queryKey: ['numberOfInvitesLeft', organizationId] }),
      ]);
      notificationsStore.addToast('success', i18next.t('InvitesDeletedSuccessfully', { ns: 'studentsPage' }), 'success');
      await callbacks?.onSuccess?.();
    },
    onError: () => notificationsStore.addToast('error', i18next.t('DeleteInvitesError', { ns: 'studentsPage' }), 'error')
  });
};
